import { Link } from 'react-router-dom'
import { ErrorState, LoadingState } from '../components/ui'
import { useOfflineQuery } from '../hooks/useOfflineQuery'
import { importStatusLabel } from '../utils/format'

interface EquipmentSourceData {
  documentId: string
  documentStatus: string
  fileName: string
  sheetName: string | null
  sourceRow: number
  sourceLocation: string | null
  externalServiceDescription: string | null
}

export function EquipmentSource({ equipmentId }: { equipmentId: string }) {
  const source = useOfflineQuery<EquipmentSourceData>(`equipment:${equipmentId}:source`, `/equipment/${equipmentId}/source`, { maxAgeMs: 60_000 })
  return <section className="surface">
    <div className="section-heading"><div><h3>Источник данных</h3><p>Сверьте карточку с исходным ППР.</p></div></div>
    {source.loading && <LoadingState label="Загружаем сведения об источнике" />}
    {source.error && <ErrorState error={source.error} onRetry={() => void source.refresh()} compact />}
    {source.data && <>
      <dl className="details-list">
        <div><dt>Документ</dt><dd><Link to={`/imports/${source.data.documentId}`}>{source.data.fileName}</Link></dd></div>
        <div><dt>Строка исходника</dt><dd>{source.data.sheetName && `Лист «${source.data.sheetName}», `}{source.data.sourceRow}</dd></div>
        <div><dt>Проверка ППР</dt><dd>{importStatusLabel(source.data.documentStatus)}</dd></div>
        {source.data.sourceLocation && <div><dt>Расположение по ППР</dt><dd>{source.data.sourceLocation}</dd></div>}
        {source.data.externalServiceDescription && <div><dt>Обслуживание подрядчиком</dt><dd>{source.data.externalServiceDescription}</dd></div>}
      </dl>
      {source.data.documentStatus === 'ARCHIVED' ? <p className="inline-notice">ППР в архиве. Источник оборудования сохранён для сверки.</p> : source.data.documentStatus !== 'CONFIRMED' && <p className="inline-notice inline-notice--warning">ППР ожидает подтверждения. Уточните замечания документа перед планированием работ.</p>}
    </>}
  </section>
}
